import React from 'react';

const Logo = ({ size = 40, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background circle */}
      <circle cx="50" cy="50" r="48" fill="url(#logoGradient)" />
      
      {/* Crescent moon */}
      <path
        d="M65 25C55 25 46.5 31 42 40C37.5 49 38 60 43 68.5C48 77 57 83 67.5 83C60 83 53 79.5 48 73.5C43 67.5 40.5 59.5 41.5 51.5C42.5 43.5 46.5 36.5 52.5 32C58.5 27.5 66 25.5 73 26.5C70.5 25.5 67.8 25 65 25Z"
        fill="#FCD34D"
      />
      
      {/* Star */}
      <path
        d="M72 35L73.5 39.5L78 40L74.5 43L75.5 47.5L72 45L68.5 47.5L69.5 43L66 40L70.5 39.5L72 35Z"
        fill="#FCD34D"
      />
      
      {/* Mosque dome silhouette */}
      <path
        d="M25 75C25 75 30 65 40 65C50 65 50 60 50 60C50 60 50 65 60 65C70 65 75 75 75 75L75 80L25 80L25 75Z"
        fill="white"
        fillOpacity="0.9"
      />
      
      {/* Minaret left */}
      <rect x="28" y="62" width="4" height="18" fill="white" fillOpacity="0.9" />
      <path d="M30 58L26 62H34L30 58Z" fill="white" fillOpacity="0.9" />
      
      {/* Minaret right */}
      <rect x="68" y="62" width="4" height="18" fill="white" fillOpacity="0.9" />
      <path d="M70 58L66 62H74L70 58Z" fill="white" fillOpacity="0.9" />
      
      {/* Central dome */}
      <ellipse cx="50" cy="60" rx="8" ry="6" fill="white" fillOpacity="0.9" />
      <rect x="48" y="52" width="4" height="8" fill="white" fillOpacity="0.9" />
      <circle cx="50" cy="50" r="2" fill="#FCD34D" />
      
      {/* Gradient definition */}
      <defs>
        <linearGradient id="logoGradient" x1="0" y1="0" x2="100" y2="100">
          <stop offset="0%" stopColor="var(--card-dark-from, #1e3a5f)" />
          <stop offset="100%" stopColor="var(--card-dark-to, #0f2744)" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
